import { useState } from "react";

import { AddMoreButton, SectionTitle } from "@components";
import { NewReward } from "./NewReward";
import { Reward } from "./Reward";

import { RewardType } from "@type/HRM/qualification";
import Accordion from "@components/Accordion";
import { Text } from "@pentabd/ui";

interface RewardPropsType {
  rewardsInfo: RewardType[];
  changeRewardsInfo: (data: RewardType) => void;
  removeRewardInfo: (rewardID: number) => void;
  getQualificationInfoRequestOngoing: boolean;
  updateRewardRequestOngoing: boolean;
  deleteRewardRequestOngoing: boolean;
  isProfileDisabled: boolean;
}

export const Rewards = ({
  rewardsInfo,
  changeRewardsInfo,
  removeRewardInfo,
  getQualificationInfoRequestOngoing,
  updateRewardRequestOngoing,
  deleteRewardRequestOngoing,
  isProfileDisabled,
}: RewardPropsType) => {
  const [newRewardFormShow, setNewRewardFormShow] = useState(false);
  const handleNewRewardFormShow = (isShow: boolean) =>
    setNewRewardFormShow(isShow);

  return (
    <div className="d-flex flex-column gap-8">
      <SectionTitle
        label="EMPLOYEE.REWARDS_INFO.FORM.REWARD_INFO.HEADING"
        size="lg"
        noBorder
      />

      {rewardsInfo?.map((reward) => (
        <Accordion
          key={reward.id}
          accordionBody={
            <Reward
              rewardInfo={reward}
              changeRewardsInfo={changeRewardsInfo}
              removeRewardInfo={removeRewardInfo}
              getQualificationInfoRequestOngoing={
                getQualificationInfoRequestOngoing
              }
              updateRewardRequestOngoing={updateRewardRequestOngoing}
              deleteRewardRequestOngoing={deleteRewardRequestOngoing}
              isProfileDisabled={isProfileDisabled}
            />
          }
          className="pointer p-8 bg-primary-25 rounded-4 border border-primary"
          accordionHeader={
            <Text size="lg" weight="semibold" color="dark">
              {reward.title}
            </Text>
          }
        />
      ))}

      {newRewardFormShow ? (
        <NewReward
          handleNewRewardFormShow={handleNewRewardFormShow}
          changeRewardsInfo={changeRewardsInfo}
          updateRewardRequestOngoing={updateRewardRequestOngoing}
          isProfileDisabled={isProfileDisabled}
        />
      ) : (
        <AddMoreButton
          label="EMPLOYEE.REWARDS_INFO.FORM.REWARD_INFO.ADD_MORE_BUTTON"
          clickAction={() => handleNewRewardFormShow(true)}
          disabled={isProfileDisabled}
        />
      )}
    </div>
  );
};

export default Rewards;
